import React, { Component } from 'react'

export default class Hero extends Component {
  render() {
    return (
      <section className="hero registrasi" id="registrasi">
      <div className="hero-body">
        <div className="container">
          <h1 className="title">{this.props.title}</h1>
          <h2 className="subtitle">{this.props.subtitle}</h2>
        </div>
      </div>
    </section>
    )
  }
}
